export function formatLedgerDatePhrases(entryDate) {
  const parsedDate = entryDate ? new Date(`${entryDate}T12:00:00`) : new Date();
  if (!parsedDate || Number.isNaN(parsedDate.getTime())) {
    return { questionPhrase: "today", summaryPhrase: "today" };
  }
  const toIso = (date) => date.toISOString().split("T")[0];
  const today = new Date();
  const todayIso = toIso(today);
  const targetIso = toIso(parsedDate);
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);
  const yesterdayIso = toIso(yesterday);
  if (targetIso === todayIso) return { questionPhrase: "today", summaryPhrase: "today" };
  if (targetIso === yesterdayIso) return { questionPhrase: "yesterday", summaryPhrase: "yesterday" };
  const formatted = parsedDate.toLocaleDateString();
  return { questionPhrase: `on ${formatted}`, summaryPhrase: formatted };
}

export function isYesResponse(input) {
  if (!input) return false;
  const n = input.trim().toLowerCase();
  return n === "y" || n === "yes" || n === "yeah" || n === "yep" || n === "sure";
}

export function isNoResponse(input) {
  if (!input) return false;
  const n = input.trim().toLowerCase();
  return n === "n" || n === "no" || n === "nope" || n === "nah";
}

export function formatRelativeTime(dateStr) {
  if (!dateStr) return "";
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `${days}d ago`;
  return new Date(dateStr).toLocaleDateString();
}
